import { createSelector } from 'reselect';

const selectRoles = (state: any) => state.roles;


export const selectRolesCurrentItem = createSelector([selectRoles], (roles) => roles.current);

export const selectRolesListItems = createSelector([selectRoles], (roles) => roles.list);

export const selectRolesItemById = (itemId: any) =>
    createSelector(selectRolesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectRolesCreatedItem = createSelector([selectRoles], (roles) => roles.create);

export const selectRolesUpdatedItem = createSelector([selectRoles], (roles) => roles.update);

export const selectRolesReadItem = createSelector([selectRoles], (roles) => roles.read);

export const selectRolesDeletedItem = createSelector([selectRoles], (roles) => roles.delete);

export const selectRolesSearchedItems = createSelector([selectRoles], (roles) => roles.search);

export const selectRolesItemsCount = createSelector([selectRoles], (roles) => roles.count);

export const selectRolesItemsFilter = createSelector([selectRoles], (roles) => roles.filter);